'use client';

import type { WebPageFeatureReturnDto } from '@terra/shared-contracts-web-pages';
import { Badge } from '../../../components/badge';
import { featureTypeColorPalette } from './feature-analysis.utils';

type FeatureTypeBadgeProps = {
  featureType: WebPageFeatureReturnDto['featureType'];
};

export const FeatureTypeBadge = ({ featureType }: FeatureTypeBadgeProps) => (
  <Badge
    variant="fill"
    size="sm"
    colorPalette={featureTypeColorPalette[featureType]}
  >
    {featureType.toUpperCase()}
  </Badge>
);
